"use strict";
import { isDelegatedEOA } from "features/smartWallet/delegation/isDelegatedEOA";
import { ensure0xHex } from "utils/hex";
export function isSmartContractAccountBytecode(code) {
  if (!code || code === "0x") {
    return false;
  }
  return !isDelegatedEOA({ bytecode: ensure0xHex(code) }).isDelegated;
}
